import React from 'react';

const HealthCheckPatternTab = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 744 800" fill="none">
      <g clip-path="url(#clip0_418_4618)">
        <rect width="744" height="800" fill="white" />
        <g opacity="0.41">
          <rect x="480.736" y="589.822" width="13.1863" height="35.4775" fill="#DDCAEB" />
          <rect x="504.91" y="600.811" width="13.1863" height="35.4775" transform="rotate(90 504.91 600.811)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="212.961" y="638.684" width="13.1863" height="35.4775" fill="#DDCAEB" />
          <rect x="237.137" y="649.673" width="13.1863" height="35.4775" transform="rotate(90 237.137 649.673)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="371.484" y="638.153" width="19.4929" height="52.4451" fill="#DDCAEB" />
          <rect x="407.221" y="654.397" width="19.4929" height="52.4451" transform="rotate(90 407.221 654.397)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="103.709" y="687.016" width="19.4929" height="52.4451" fill="#DDCAEB" />
          <rect x="139.445" y="703.259" width="19.4929" height="52.4451" transform="rotate(90 139.445 703.259)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="454.137" y="613.988" width="9.74643" height="26.2225" fill="#DDCAEB" />
          <rect x="472.006" y="622.11" width="9.74643" height="26.2225" transform="rotate(90 472.006 622.11)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="186.361" y="662.85" width="9.74643" height="26.2225" fill="#DDCAEB" />
          <rect x="204.23" y="670.972" width="9.74643" height="26.2225" transform="rotate(90 204.23 670.972)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="408.59" y="583.138" width="12.9952" height="34.9634" fill="#DDCAEB" />
          <rect x="432.414" y="593.967" width="12.9952" height="34.9634" transform="rotate(90 432.414 593.967)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="140.814" y="632" width="12.9952" height="34.9634" fill="#DDCAEB" />
          <rect x="164.639" y="642.829" width="12.9952" height="34.9634" transform="rotate(90 164.639 642.829)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="297.314" y="589.822" width="9.74643" height="26.2225" fill="#DDCAEB" />
          <rect x="315.184" y="597.944" width="9.74643" height="26.2225" transform="rotate(90 315.184 597.944)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="365.701" y="560" width="9.74643" height="26.2225" fill="#DDCAEB" />
          <rect x="383.57" y="568.122" width="9.74643" height="26.2225" transform="rotate(90 383.57 568.122)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="271.092" y="560" width="9.74643" height="26.2225" fill="#DDCAEB" />
          <rect x="288.961" y="568.122" width="9.74643" height="26.2225" transform="rotate(90 288.961 568.122)" fill="#DDCAEB" />
        </g>
        <path opacity="0.18" d="M452.825 738.125C368.942 710.691 115.99 742.346 0 761.603V800.116H744V561.385C660.391 554.527 517.999 569.721 617.302 685.367C716.604 801.013 549.027 768.725 452.825 738.125Z" fill="#7F4A9B" />
      </g>
      <defs>
        <clipPath id="clip0_418_4618">
          <rect width="744" height="800" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HealthCheckPatternTab;